module.exports = __webpack_public_path__ + "img/pavot_annuel.747147d9.jpg";